const constants = {
  spf: {
    homologar: "homologar",
    revisao: "revisao",
    todos: "todos",
  },
  paginationComponentOptions: {
    rowsPerPageText: "Registros por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  },
};
export default constants;
